import React, { useMemo } from "react"

import { Section, Block } from "../Sandbox"
import { COLOR_SCHEMES, GENERIC_COLORS } from "./ColorSchemes"
import _ from "lodash"

const EX_W = 300
const EX_H = 300
const EX_OFF = 10

const boxWithText = (x: number, y: number, w: number, h: number, txt: string, bgCol: string, txtCol: string, borderRadius?: number) => {
  return `
    <rect x="${x}" y="${y}" width="${w}" height="${h}" fill="${bgCol}" rx="${borderRadius ?? 0}" />
    <text x="${x + w / 2}" y="${y + h / 2 + 6}" fill="${txtCol}" font-size="16" text-anchor="middle">${txt}</text>
  `
}

const example = (themeName: string, t: Quiz.Api.QuizColorTheme, x: number, y: number, mode: "dark" | "light") => {
  const TXT_COL = GENERIC_COLORS.text[mode]
  const BTN_COL = GENERIC_COLORS.buttonBg[mode]
  const BTN_TXT_COL = GENERIC_COLORS.buttonText[mode]

  return `
    <rect x="${x}" y="${y}" width="${EX_W}" height="${EX_H}" fill="${t.cardBorder[mode]}" rx="0" />
    <rect x="${x + EX_OFF}" y="${y+ EX_OFF}" width="${EX_W - 2 * EX_OFF}" height="${EX_H - 2 * EX_OFF}" fill="${t.cardBg[mode]}" rx="0" />
    ${boxWithText( /* intense */
      x + EX_OFF,
      y + EX_OFF,
      EX_W - 2 * EX_OFF,
      EX_OFF * 4,
      `${themeName} - ${mode}`,
      t.cardBgIntense[mode],
      TXT_COL,
    )}
    ${boxWithText(
      x + 2 * EX_OFF,
      y + 6 * EX_OFF,
      EX_W - 4 * EX_OFF,
      EX_OFF * 4,
      "Question header (bgSubtle)",
      t.cardBgSubtle[mode],
      TXT_COL,
    )}
    ${boxWithText(
      x + 2 * EX_OFF,
      y + 11 * EX_OFF,
      EX_W - 4 * EX_OFF,
      EX_OFF * 4,
      "Question",
      t.cardBg[mode],
      TXT_COL,
    )}
    <rect x="${x + EX_OFF}" y="${y + 15 * EX_OFF}" width="${EX_W - 2 * EX_OFF}" height="${60 + 2 * EX_OFF}" fill="${t.cardBgIntense[mode]}" rx="0" />
    ${boxWithText(
      x + EX_W / 2 - 30,
      y + 16 * EX_OFF,
      60,
      60,
      "4",
      t.roundNumberProgress[mode],
      TXT_COL,
      30
    )}
    ${boxWithText(
      x + EX_W / 2 - 20,
      y + 16 * EX_OFF + 10,
      40,
      40,
      "4",
      t.roundNumberBg[mode],
      TXT_COL,
      20
    )}
    ${boxWithText( /* button */
      x + 3 * EX_OFF,
      y + EX_H - 6 * EX_OFF,
      EX_W - 6 * EX_OFF,
      EX_OFF * 4,
      "Button",
      BTN_COL,
      BTN_TXT_COL,
    )}
  `
}

const SCHEME_INFO: Record<string, string> = {
  "0": "only used on title page",
  "2": "also used on final result screen",
}

const ColorSchemesSandbox: React.FC = () => {
  const innerSVG = useMemo(() => {
    const themes = _.keys(COLOR_SCHEMES)

    return `
      <svg height="${themes.length * EX_H}" width="${EX_W * 2}" xmlns="http://www.w3.org/2000/svg">
        ${_.chain(COLOR_SCHEMES).toPairs().map((pair, index) => `
          ${example(pair[0] + (SCHEME_INFO[pair[0]] ? ` ${SCHEME_INFO[pair[0]!]}` : ""), pair[1], 0, index * EX_H, "light")}
          ${example(pair[0], pair[1], EX_W, index * EX_H, "dark")}
        `).join("\n")}
      </svg>
    `
  }, [])

  return <div>
    <Section title="All schemes as SVG">
      <Block>
        <div dangerouslySetInnerHTML={{__html: innerSVG}} />
      </Block>
    </Section>
  </div>
}

export default ColorSchemesSandbox
